<template>
  <TheUncle :color="true" title="사입 목록" description="처리중인 사입 목록입니다.">
    <WholesaleMessage v-if="$store.state.uncle.sending" />
    <a-button
      style="width: 100%; margin-bottom: 0.3em;"
      type="primary"
      icon="message"
      @click="openMessage"
    >문자</a-button>
    <a-collapse v-model="locations.map(({ idx }) => idx)">
      <a-collapse-panel
        :header="
          `${location.name} - ( ${location.total} / ${location.waiting} )`
        "
        v-for="location in locations"
        :key="location.idx"
      >
        <a-card title="건물명">
          <a-breadcrumb slot="extra">
            <a-breadcrumb-item style="color: black">합계</a-breadcrumb-item>
            <a-breadcrumb-item style="color: #a39a00">대기</a-breadcrumb-item>
          </a-breadcrumb>
        </a-card>
        <a-card
          :title="secondary.name"
          @click="$router.push(`/uncle/pending/${secondary.idx}`)"
          style="background-color: #e9ecef"
          v-for="secondary of location.secondarys"
          :key="secondary.idx"
        >
          <a-breadcrumb slot="extra">
            <a-breadcrumb-item style="color: black">{{ secondary.total }} 개</a-breadcrumb-item>
            <a-breadcrumb-item style="color: #a39a00">{{ secondary.waiting }} 개</a-breadcrumb-item>
          </a-breadcrumb>
        </a-card>
      </a-collapse-panel>
    </a-collapse>
  </TheUncle>
</template>
<script>
import TheUncle from "@/components/Uncle/TheUncle";
import Axios from "axios";
import config from "../../../config";
import AxiosMiddleware from "../../../libs/AxiosMiddleware";
import OPCODE from "../../../libs/OPCODE";
import { mapMutations } from "vuex";
import { TYPES } from "../../../stores/uncle";
import WholesaleMessage from "../../../components/Wholesale/WholesaleMessage";

export default {
  name: "UnclePending",
  components: { TheUncle, WholesaleMessage },
  methods: {
    ...mapMutations([TYPES.UNCLE_SEND_MESSAGE]),
    openMessage() {
      this[TYPES.UNCLE_SEND_MESSAGE](true);
    },
    async onLoad() {
      try {
        const { data } = await Axios.get(
          `${config.hostname}/v1/uncle/saib/pending`,
          {
            withCredentials: true
          }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.locations = data.locations;
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "오류가 발생했습니다. 관리자에게 문의하세요."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "오류가 발생했습니다. 인터넷 상태를 확인해주세요."
        });
      }
    }
  },
  data() {
    this.onLoad();
    return {
      locations: []
    };
  }
};
</script>
<style scoped>
.ant-collapse-content > .ant-collapse-content-box {
  padding: 2px;
}
</style>
